import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { Settings } from "./Settings";
import { GameManager } from "../Managers/GameManager";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { ModuleManager } from "../Managers/ModuleManager";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { SymbolExtended } from "./SymbolExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    static BonusOnReel: string = "eventBonusOnReel";

    public static Tease: boolean = false;
    public static TeaseIndex: number = null;

    sortSymbols() {
        if (!this.symbols.hasZindex) {
            return;
        }
        let addQueue: Symbol[] = [];
        this.currentSymbols.forEach((symbol) => {
            addQueue.push(<Symbol>symbol);
        });
        addQueue.sort((a, b) => a.zIndex - b.zIndex);
        addQueue.forEach((symbol) => {
            this.addChild(symbol);
        });
    }

    public showSymbols(useTransform: boolean = false): void {
        super.showSymbols();
        this.sortSymbols();
    }

    protected getSymbol(symbolId: number, symbolCase: string, fromStrip: boolean): Symbol {
        const symbol = this.symbols.getSymbol(symbolId, symbolCase);
        if (symbol.id === Settings.SymbolWild - 1) {
            let currentMultiplier = 1;
            if (
                GameManager.freespinsResponse &&
                GameManager.freespinsResponse.freeSpins &&
                GameManager.freespinsResponse.freeSpins.multiplier
            ) {
                currentMultiplier = FreespinsView.Multiplier;
            }
            if (symbol.id === Settings.SymbolWild - 1) {
                const bg = symbol.getChildElementByName("Body");
                const fg = symbol.getChildElementByName("Text");
                if (bg && bg instanceof ContainerElement && fg && fg instanceof ContainerElement) {
                    const mul = fg.getChildElementByName("Multiplier");
                    const zero = bg.getChildElementByName("Zero");
                    if (mul && mul instanceof ImageTextElement && zero && zero instanceof ImageElement) {
                        if (ModuleManager.freespinsActive()) {
                            if (zero && zero instanceof ImageElement) {
                                zero.visible = false;
                            }
                            mul.setText("x" + currentMultiplier.toString());
                        } else {
                            if (zero && zero instanceof ImageElement) {
                                zero.visible = true;
                            }
                            mul.setText("");
                        }
                    }
                }
            }
        }
        if (symbol.id === Settings.SymbolBonus - 1) {
            if (!this.isStopping || this.data.symbols.filter((s) => s == Settings.SymbolBonus).length) {
                this.emit(ReelExtended.BonusOnReel, this.index);
            }
        }
        if (ReelExtended.Tease) {
            symbol.goToCase(SymbolExtended.CaseTeasingBlur);
        }
        return symbol;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/